module.exports = __webpack_public_path__ + "static/media/medical-emergency.729f8021.svg";